import { render } from "./DemographicReportParametres.vue?vue&type=template&id=630af6a4"
import script from "./DemographicReportParametres.vue?vue&type=script&lang=js"
export * from "./DemographicReportParametres.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__